<template>
  <pl-dialog
    title="New Instruction"
    size="relative_sm"
    :isBeta="true"
    :disableOutsideClick="true"
    @close="$emit('close')"
  >
    <div class="w-full h-full flex flex-col justify-between space-y-5 px-5 overflow-y-auto pb-4 -mt-2">
      <div>
        <p class="text-sm text-gray-600 font-manrope">Instruct the Genie to give feedback in a custom way. For example, "simplify feedback for English Language Learners", "ask a question about the student's thinking" or "make it silly".</p>
      </div>
      <div class="flex flex-col space-y-3 ml-1">
        <div class="w-full font-manrope flex flex-col space-y-2">
          <label class="text-sm text-gray-800">Name <span class="text-red-500">*</span></label>
          <div class="flex w-full items-center bg-gray-100 rounded-md focus-within:ring-2 focus-within:ring-primary focus-within:ring-offset-2 focus-within:ring-offset-primary-new_light transition-all duration-150 ease-in-out">
            <input v-model="instruction.name" placeholder="Enter a instruction title..." type="text" class="bg-transparent px-3 py-1.5 rounded-md focus:outline-none w-full" />
          </div>
        </div>
        <div class="w-full font-manrope flex flex-col space-y-2">
          <label class="text-sm text-gray-800">Instruction <span class="text-red-500">*</span></label>
          <div class="w-full bg-gray-100 rounded-md focus-within:ring-2 focus-within:ring-primary focus-within:ring-offset-2 focus-within:ring-offset-primary-new_light transition-all duration-150 ease-in-out">
            <textarea v-model="instruction.prompt" placeholder="Enter a instruction prompt..." rows="2" class="bg-transparent resize-none px-3 py-2 rounded-md focus:outline-none w-full"></textarea>
            <div class="flex justify-end items-center pb-2 px-2 text-xs">
              {{ instruction.prompt.length }} / 200
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-end space-x-2">
        <div class="flex items-center space-x-2">
          <button @click="$emit('close')" type="button" class="px-4 py-2 text-gray-800 bg-white rounded-md hover:bg-gray-100 transition">
            Cancel
          </button>
          <button @click="handleSaveInstruction()" type="submit" class="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-dark transition">
            Save
          </button>
        </div>
      </div>
    </div>
  </pl-dialog>
</template>
<script>

import { EventBus } from '../../../utils/event-bus';
import updateUser from 'services/account/updateUser';
import { mapGetters } from 'vuex';

  export default {
    name: 'NewInstructionFeedback',
    data() {
      return {
        instruction: {
          name: '',
          prompt: '',
        },
      };
    },
    computed: {
      ...mapGetters([
        'getProfile',
      ]),
    },
    methods: {
      handleSaveInstruction: async function() {
        if (this.instruction.prompt.length > 200) {
          EventBus.$emit('createToast', { type: "Error", message: "Instruction prompt cannot exceed 200 characters", time: 5000 });
          return;
        }
        const existingInstructions = Array.isArray(this.getProfile.instructions) ? this.getProfile.instructions : [];
        const idTag = string => {
          return string.replace(/\W+/g, " ").split(/ |\B(?=[A-Z])/).map(word => word.toLowerCase()).join('_');
        };
        const updatedInstructions = [...existingInstructions, { id: idTag(this.instruction.name), title: this.instruction.name, prompt: this.instruction.prompt, checked: true }];

        try {
          const response = await updateUser(this.getProfile.id, {
            instructions: updatedInstructions
          });
          this.$store.dispatch('setAccount', response.data);
          EventBus.$emit('createToast', { type: 'Success', message: 'Instruction added successfully!', time: 5000 });
          this.$emit('close');
        } catch (error) {
          console.error(error);
          EventBus.$emit('createToast', { type: "Error", message: "Something happened creating new instruction, please try again", time: 5000 });
        }
      }
    },
    mounted: function() {

    },
    beforeDestroy: function() {
      if (!this.$route.query.popup) {
        this.$router.replace({ query: { grader: true } });
      }
      
      if (this.$route.query.grader && this.$route.query.grader === true) {
        EventBus.$emit('genie_grader_confirm_modal', true);
      }
    }
  };
</script>

<!-- <style scoped>

.input {
 width: 100%;
 height: 40px;
 line-height: 28px;
 padding: 0 1rem;
 border: 2px solid transparent;
 border-radius: 8px;
 outline: none;
 background-color: #f3f3f4;
 color: #0d0c22;
 transition: .3s ease;
}


.input:focus {
 outline: none;
 border-color: rgba(114, 204, 215, 0.4);
 box-shadow: 0 0 0 4px rgba(114, 204, 215, 10%);
}


</style> -->



// WEBPACK FOOTER //
// InstructionsFeedback.vue?e32b8cee